module.exports = __webpack_public_path__ + "img/Mockup_1_small.93790c03.jpg";